import { setGoogleMapApiKey } from './helpers/googleMap/loadGoogleMap';
import { clearSessionStorage } from './sessionStorageKeys';

clearSessionStorage();

export default async ({ sparkyFramework, vars }) => {
  // eslint-disable-next-line no-undef
  const envName = (vars ?? {}).env_name || process.env.ENV_NAME;
  const logStyle =
    'color:#fa582d; background:#141414; font-size:0.85rem; padding:0.5rem; margin: 0.15rem auto; font-family: Rockwell; border: 2px solid #fa582d; border-radius: 4px;font-weight: bold; text-shadow: 1px 1px 1px #141414;';
  console.log(`%c adem ui env: ${envName} 🌏`, logStyle);
  // eslint-disable-next-line no-undef
  console.log(`%c adem ui version: ${process.env.APP_VERSION} 📦`, logStyle);

  if (envName === 'staging') {
    // eslint-disable-next-line no-undef
    console.info(
      '%c release changelog 🚀: ',
      logStyle,
      `https://prisma-access.docs.pan.run/sase-adem-group/dem-ui/changelog.html`
    );
  }

  setGoogleMapApiKey(
    // eslint-disable-next-line no-undef
    vars?.google_map_api_key || process.env.GOOGLE_MAP_API_KEY
  );

  return async ({ auth }) => {
    const { setUpManager } = await import('./index.utils');
    console.log('TenantInfo', auth?.tsg_id, vars);

    await setUpManager(sparkyFramework, auth, vars);
    const { cosmosFeatures } =
      sparkyFramework.getState()?.saseIAMainState ?? {};
    const isFeatureEnabled = (featureName, defaultValue) => {
      if (!cosmosFeatures?.length) {
        return Boolean(defaultValue);
      }
      return cosmosFeatures
        .find((data) => data.feature === featureName)
        ?.permission?.includes('read');
    };

    //For Phase 1, we want to show both Monitor and Insights, GA will remove users and application from Monitor
    //const frameworkVars = sparkyFramework.getFrameworkVars();
    // const { private_site_origin } = frameworkVars;
    // const isPrivateApp = Boolean(private_site_origin);

    return {
      navigation: () => [
        {
          key: 'settings',
          title: 'Settings',
          path: '/settings',
          noRBACheck: true,
          expandable: true,
          mergeNav: true,
          children: [
            {
              key: 'dem-settings',
              title: 'Application Experience',
              contentClassName: 'dem-settings',
              path: '/settings/dem-settings',
              exact: true,
              noRBACheck: true,
              hidden: !isFeatureEnabled(
                'panw_sase:settings_system_application',
                true
              ),
              component: () =>
                import('./saseViews/settingsView/SettingsViewWrapper'),
            },
          ],
        },
        {
          key: 'monitor',
          title: 'Monitor',
          path: '/monitor',
          noRBACheck: true,
          expandable: true,
          mergeNav: true,
          children: [
            {
              key: 'monitor-palocations',
              title: 'Prisma Access Locations',
              contentClassName: 'monitor-palocations',
              path: '/monitor/palocations',
              exact: false,
              noRBACheck: true,
              hidden: !isFeatureEnabled('panw_sase:pa_location', true),
              component: () =>
                import(
                  './saseViews/prismaLocationView/PrismaLocationViewWrapper'
                ),
            },
            {
              key: 'monitor-users',
              title: 'Users',
              contentClassName: 'monitor-users',
              path: '/monitor/users',
              exact: false,
              noRBACheck: true,
              //hidden: !isPrivateApp || !isFeatureEnabled('panw_sase:users', true),
              component: () => import('./saseViews/usersView/UsersViewWrapper'),
            },
            {
              key: 'monitor-dem-application',
              title: 'Prisma Access Dem Application',
              contentClassName: 'monitor-dem-application',
              path: '/monitor/applications/dem-application',
              exact: false,
              noRBACheck: true,
              hidden: true,
              // AppDetailsViewWrapper contains:
              // 1. App Experience Details
              // 2. Manage App Tests
              // 3. Edit/New App Test
              component: () =>
                import('./saseViews/appsView/AppDetailsViewWrapper'),
            },
            {
              key: 'monitor-remote-sites',
              title: 'Prisma Access Site Details',
              contentClassName: 'monitor-site-details',
              path: '/dem/dem-remote-sites/details',
              exact: true,
              hidden: true,
              noRBACheck: true,
              component: () =>
                import(
                  './saseViews/sitesView/SiteDetails/SiteDetailsViewWrapper'
                ),
            },
          ],
        },
        {
          key: 'adem_export_user',
          title: 'Hidden Users',
          path: '/insights/activity_insights_user/users',
          noRBACheck: true,
          children: [
            {
              key: 'adem-export-user-details',
              title: 'Users',
              contentClassName: 'monitor-users',
              path: '/insights/activity_insights_user/users',
              exact: false,
              noRBACheck: true,
              hidden: true,
              component: () =>
                import('./saseViews/usersView/UsersViewDetailsWrapper'),
            },
          ],
        },
        {
          key: 'adem_export_app',
          title: 'Hidden App',
          path: '/insights/activity_insights_app/apps',
          noRBACheck: true,
          children: [
            {
              key: 'adem-export-app-details',
              title: 'Prisma Access Dem Application',
              contentClassName: 'monitor-dem-application',
              path: '/insights/activity_insights_app/apps',
              exact: false,
              noRBACheck: true,
              hidden: true,
              // AppDetailsViewWrapper contains:
              // 1. App Experience Details
              // 2. Manage App Tests
              // 3. Edit/New App Test
              component: () =>
                import('./saseViews/appsView/AppDetailsViewWrapper'),
            },
          ],
        },
      ],
      exposes: {
        default: {
          DemSummaryViewWrapper: () =>
            import('./saseViews/summaryView/SummaryViewWrapper'),
          DemSettingsViewWrapper: () =>
            import('./saseViews/settingsView/SettingsViewWrapper'),
          PrismaLocationViewWrapper: () =>
            import('./saseViews/prismaLocationView/PrismaLocationViewWrapper'),
          ApplicationsViewWrapper: () =>
            import('./saseViews/appsView/AppsViewWrapper'),
          DemDeviceExpCard: () =>
            import('./saseViews/components/deviceExpCard/index'),
          IncidentExperienceTrend: () =>
            import('./saseViews/incidentsView/IncidentExperienceTrendWrapper'),
          SiteApplicationExpScore: () =>
            import(
              './saseViews/sitesView/SitesApplicationExpScore/SitesAppExpScoreWrapper'
            ),
          DemSiteDetailsViewWrapper: () =>
            import('./saseViews/sitesView/SiteDetails/SiteDetailsViewWrapper'),
          DemApplicationDetailsViewWrapper: () =>
            import(
              './saseViews/components/AppDetailsExperienceView/AppDetailsExperienceViewWrapper'
            ),
          DemUserDetailsExpViewWrapper: () =>
            import(
              './saseViews/components/UserDetailsExperienceView/UserDetailsExperienceViewWrapper'
            ),
          ADEMLicenseAllocation: () =>
            import(
              './saseViews/ademLicenseActivationView/AdemLicenseActivationView'
            ),
          ConnectedAccAppsSummaryWrapper: () =>
            import(
              './saseViews/acceleratedAppsView/components/connectedAccAppsSummary/ConnectedAccAppsSummaryWrapper'
            ),
          ConnectedDataAvgThroughputWrapper: () =>
            import(
              './saseViews/acceleratedAppsView/components/connectedDataAvgThroughput/ConnectedDataAvgThroughputWrapper'
            ),
        },
      },
    };
  };
};
